import { modifier } from 'ember-modifier';

interface ScrollOnChangeSignature {
  Element: Element;
}

export default modifier<ScrollOnChangeSignature>(
  function scrollOnChange(element) {
    element.scrollIntoView({ behavior: 'smooth' });
  },
);
